import { request } from './client.js';
import { toQuery } from '../utils/params.js';

export const referenceDataApi = {
  getMergedSites:  (params = {}) => request(`/api/reference-data/sites${toQuery(params)}`),
  getLaborMetrics: (params = {}) => request(`/api/reference-data/labor-metrics${toQuery(params)}`),
  getCostCenters:  (params = {}) => request(`/api/reference-data/cost-centers${toQuery(params)}`),
  getTaskMapping:  (params = {}) => request(`/api/reference-data/task-mapping${toQuery(params)}`),
  getMirrorLocations: () => request('/api/reference-data/mirror-locations'),
  toggleInclude: (table, code, included) =>
    request('/api/reference-data/toggle-include', {
      method: 'POST',
      body: JSON.stringify({ table, code: String(code), included }),
    }),
  updateOtThreshold: (siteCode, threshold) =>
    request('/api/reference-data/update-ot-threshold', {
      method: 'POST',
      body: JSON.stringify({ site_code: siteCode, threshold }),
    }),
  // Per-site TAB07 Customer-OT recalculation switch. Stated positively —
  // enabled=true (the default) runs the recalc. The column stores the negative
  // (ot_recalc_disabled); the backend owns that inversion.
  updateOtRecalc: (siteCode, enabled) =>
    request('/api/reference-data/update-ot-recalc', {
      method: 'POST',
      body: JSON.stringify({ site_code: siteCode, enabled }),
    }),
  // Per-site Training / Drug-Screening billability (flag =
  // training_billable | drug_screen_billable).
  updateSiteBillability: (siteCode, flag, billable) =>
    request('/api/reference-data/update-site-billability', {
      method: 'POST',
      body: JSON.stringify({ site_code: siteCode, flag, billable }),
    }),
  updateTaskExclusion: (laborMetricsCode, column, value) =>
    request('/api/reference-data/task-mapping/exclusion', {
      method: 'POST',
      body: JSON.stringify({ labor_metrics_code: laborMetricsCode, column, value }),
    }),
};
